import { productionRuntime } from '@post-office/placement-common-v2/placement-runtime';

import { PlacementBackend, PlacementFrontend } from '@post-office/placements--growth-transmuters/share-and-permissions-modal';

import { withI18n } from './i18n';

export const placementBackendFactory = PlacementBackend.createPlacementBackend({
				messageTemplates: [],
			})

export const RawPlacement = PlacementFrontend.createPlacementFrontendComponent({
				messageTemplates: []
			});

export const Placement = withI18n(RawPlacement)

export const SSRPlacement = RawPlacement

export const middleware = placementBackendFactory(productionRuntime);